import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { fetchOrganization } from '@common/resources/Organization/actions';
import { fetchShop, clearShop } from '@resources/Shop/actions';
import { fetchSubmodulesByModuleCode } from '@resources/Submodule/actions';
import { Box, Container, View, Title } from '@common/components';
import { Affix, Menu, Typography } from 'antd';

const ShopInfo = ({
	shop,
	submodules,
	fetchShop,
	fetchSubmodulesByModuleCode,
	organization,
	history,
	match,
}) => {
	const { shopId, submoduleCode } = match?.params || {};
	const [current, setCurrent] = useState(submoduleCode || 'details');

	useEffect(() => {
		const fetchData = async () => {
			await fetchShop(shopId);
			await fetchSubmodulesByModuleCode('shop');
		};

		fetchData();
	}, [fetchShop]);

	const handleClick = (e) => {
		if (e.key === 'details') {
			history.push(
				organization.alias
					? `/${organization.alias}/shops/${shopId}/details`
					: `/shops/${shopId}/details`
			);
		} else {
			history.push(
				organization.alias
					? `/${organization.alias}/shops/${shopId}/details/${e.key}`
					: `/shops/${shopId}/details/${e.key}`
			);
		}

		setCurrent(e.key);
	};

	return (
		<View>
			<Container>
				<Box py={50}>
					<Title fontSize={100} lineHeight={1} mb={10}>
						{shop.name}
					</Title>
					<Typography.Title level={2}>Shop</Typography.Title>
				</Box>
				<Affix offsetTop={100}>
					<Menu
						onClick={handleClick}
						mode="horizontal"
						selectedKeys={[current]}>
						<Menu.Item key="details">Details</Menu.Item>
						{submodules &&
							submodules.map((submodule) => (
								<Menu.Item key={submodule.url}>
									{submodule.title}
								</Menu.Item>
							))}
					</Menu>
				</Affix>
			</Container>
		</View>
	);
};

const mapStateToProps = ({ shop, submodules, organization }) => {
	return {
		shop,
		submodules,
		organization,
	};
};

export default connect(mapStateToProps, {
	fetchShop,
	fetchSubmodulesByModuleCode,
	fetchOrganization,
	clearShop,
})(ShopInfo);
